// main components
import React from 'react'
import { useTranslation } from 'react-i18next'

// mui components
import { Typography, Card, CardContent, CardActions, Box } from '@mui/material'

import { rolesCardStyles } from '../../styles/classes/CompanySettingsClasses'
import { accessRoles } from '../../utils/global'

export const RolesCard = (props) => {
  const { roles } = props
  const { classes } = rolesCardStyles()
  const { t } = useTranslation()

  const roleMessage = (role) => {
    switch (role) {
      case accessRoles.ADMIN:
        return t('company_settings.admin_access')
      case accessRoles.COORDINATOR:
        return t('company_settings.coordinator_access')
      case accessRoles.FORM_BUILDER:
        return t('company_settings.form_builder_access')
      case accessRoles.VIEW_ONLY:
        return t('company_settings.view_only_access')
      default:
        return ''
    }
  }

  return (
    <Card className={classes.card} data-testid={'roles_card'}>
      <CardActions disableSpacing classes={{ root: classes.actions }}>
        <Typography classes={{ root: classes.title }}>
          {t('company_settings.card.access')}
        </Typography>
        {/* TODO HANDLE ADDING ROLES */}
        {/* {userHasAuthorization(accessStore) && (
          <IconButton
            aria-label="delete"
            classes={{ root: classes.addButton }}
            onClick={handleNewPanel}
            data-testid={"add_company_access_button"}
          >
            <AddCircleRounded />
          </IconButton>
        )} */}
      </CardActions>
      <CardContent>
        {roles?.map((role, index) => {
          return <div key={`${role}- ${index}`} >
            <Box display="flex" flexDirection="row" alignItems="center" className={classes.content}>
            <Typography classes={{ root: classes.roleItem }}>
              {role.name}
            </Typography>
            <Typography classes={{ root: classes.roleAccess }}>
              {roleMessage(role.name)}
            </Typography>
          </Box>
          {index !== roles?.length - 1 && <div className={ classes.separator } />}
        </div>
        })}
      </CardContent>
    </Card>
  )
}
